export default __webpack_public_path__ + "static/media/151-reparation.2df37c2c.png";